export var doc = function doc() {
  for (var _len = arguments.length, content = new Array(_len), _key = 0; _key < _len; _key++) {
    content[_key] = arguments[_key];
  }
  return {
    type: 'doc',
    version: 1,
    content: content
  };
};